export const mapCompletionNotificationSettingsFromApi = (settings) => {
  if (!settings) {
    return {
      notifyRecipients: false,
      notifyDirectManager: false,
    }
  }

  return {
    notifyRecipients: settings.notifyRecipients ?? settings.notify_recipients ?? false,
    notifyDirectManager: settings.notifyDirectManager ?? settings.notify_direct_manager ?? false,
  }
}
